import { render, staticRenderFns } from "./zen_no_questions.vue?vue&type=template&id=fb73175e&scoped=true&"
import script from "./zen_no_questions.vue?vue&type=script&lang=js&"
export * from "./zen_no_questions.vue?vue&type=script&lang=js&"
import style0 from "./zen_no_questions.vue?vue&type=style&index=0&id=fb73175e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb73175e",
  null
  
)

export default component.exports